/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useMemo } from 'react';
import { userSelectors } from '../../../../app/resource/user/user.selectors';
import { useSelectWithParams } from '../../../../utils/selector.utils';
import { IMeetingAttendeesProps } from './types';
import { CircularAvatar } from '../../../pages/common/CustomAvatar';

export const MeetingAttendees: FunctionComponent<IMeetingAttendeesProps> = ({ userIds, isOnline }) => {
  const title = useMemo(() => (isOnline ? 'Online' : 'Offline'), [isOnline]);

  const users = useSelectWithParams(userSelectors.selectResourcesById, userIds);

  return (
    <div className="single-card-container" style={isOnline ? { width: '50%', marginRight: '20px' } : { width: '50%' }}>
      <div className="panel-body px-0" style={{ height: '100%' }}>
        <div className="border-radius-1 lightGray-bg px-2 pb-1" style={{ height: '100%' }}>
          <div className="panel-header p-0" style={{ flexDirection: 'column', height: '100%' }}>
            <h2 className="bold" style={{ marginTop: '20px' }}>
              {title}
            </h2>
            <div className="todo-container tabs">
              {users.map(
                (user) =>
                  user && (
                    <a
                      className="btn white-bg darkGray dropdown-button small-shadow f-14 mx-0"
                      title={`${user.firstName} ${user.lastName}`}
                      key={user.id}
                      style={{ marginTop: '10px', cursor: 'default' }}
                    >
                      <CircularAvatar
                        src={user.image}
                        title={`${user.firstName} ${user.lastName}`}
                        classes="mr-1"
                        cursorPointer={false}
                      />
                      {`${user.firstName} ${user.lastName}`}
                    </a>
                  ),
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
